import Swiper from "swiper";

export default function MakeProductSlider() {

    let productSlider = new Swiper('.product-slider .swiper-container', {
        slidesPerView: 'auto',
        spaceBetween: 30,
        centeredSlides: true,
        autoplay: 5000,
        //loop: true,
        breakpoints: {
            768: {
                spaceBetween: 40,
                centeredSlides: false
            }
        }
    })

    let nextBtn = $('.js-product-slider-next-btn');
    let prevBtn = $('.js-product-slider-previous-btn');

    nextBtn.on('click', () => {
        productSlider.slideNext();
    })

    prevBtn.on('click', () => {
        productSlider.slidePrev();
    })

    productSlider.on('slideChange', (swiper) => {




    })

    productSlider.on('fromEdge', (swiper) => {
        nextBtn.removeClass('swiper-button-disabled');
        prevBtn.removeClass('swiper-button-disabled');
    })

    productSlider.on('reachBeginning', () => {
        prevBtn.addClass('swiper-button-disabled');
    })

    productSlider.on('reachEnd', () => {
        nextBtn.addClass('swiper-button-disabled');
    })

    return productSlider;
}
